import { zodResolver } from '@hookform/resolvers/zod'
import { SubmitHandler, useForm } from 'react-hook-form'
import { getDepositSplitSchema } from './deposit-split-schema'
import { z } from 'zod'
import { DepositSplit } from '../deposit-split'
import { useCustomError } from 'src/utils/custom-errors.hook'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import useFormatCurrency from 'src/app/hooks/current-locale/use-format-currency'
import { useTenant } from 'src/app/hooks/context/context.hook'

const DepositSplitSchema = getDepositSplitSchema()
type DepositSplit = z.TypeOf<typeof DepositSplitSchema>

export const useDepositSplitForm = (amount: number, onSave: (data: DepositSplit) => void) => {
  const { t } = useTranslation()
  const { currency } = useTenant()
  const { formatCurrency } = useFormatCurrency()
  const depositSplitSchema = getDepositSplitSchema(amount, t, currency, formatCurrency)

  const customErrorMap = useCustomError()
  z.setErrorMap(customErrorMap)

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm<DepositSplit>({ resolver: zodResolver(depositSplitSchema) })

  const submitHandler: SubmitHandler<DepositSplit> = useCallback(
    async (data: DepositSplit) => {
      onSave(data)
    },
    [onSave],
  )

  const onSubmit = useCallback(handleSubmit(submitHandler), [handleSubmit, submitHandler])

  return { control, onSubmit, errors, reset, setValue, depositSplitSchema }
}
